import { render, staticRenderFns } from "./AddAttendeeModal.vue?vue&type=template&id=4aa2ab2f&scoped=true"
import script from "./AddAttendeeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAttendeeModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddAttendeeModal.vue?vue&type=style&index=0&id=4aa2ab2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2ab2f",
  null
  
)

export default component.exports